import { Link } from "@remix-run/react";

export default function TermsOfService() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <p className="mb-4">Welcome to BoostedPins. By using our service, you agree to these terms. Please read them carefully.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">1. Use of Service</h2>
      <p className="mb-4">BoostedPins provides a platform for Shopify merchants to automate and optimize their Pinterest presence. You must use this service responsibly and in compliance with all applicable laws and regulations.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">2. Account Registration</h2>
      <p className="mb-4">To use BoostedPins, you must create an account. You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">3. Payment and Subscription</h2>
      <p className="mb-4">Some features of BoostedPins require a paid subscription. By subscribing to a paid plan, you agree to pay the fees associated with that plan. We reserve the right to change our pricing with notice.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">4. Content</h2>
      <p className="mb-4">You retain all rights to the content you post through our service. By using BoostedPins, you grant us a license to use, modify, and distribute your content as necessary to provide and improve our service.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">5. Termination</h2>
      <p className="mb-4">We reserve the right to terminate or suspend your account at any time for any reason, without notice.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">6. Disclaimer of Warranties</h2>
      <p className="mb-4">BoostedPins is provided "as is" without any warranties, express or implied.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">7. Limitation of Liability</h2>
      <p className="mb-4">BoostedPins shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the service.</p>
      
      <h2 className="text-2xl font-semibold mt-6 mb-4">8. Changes to Terms</h2>
      <p className="mb-4">We may modify these terms at any time. Your continued use of BoostedPins after any changes indicates your acceptance of the new terms.</p>
      
      <p className="mt-8">If you have any questions about these Terms of Service, please <Link to="/contact" className="text-blue-600 hover:underline">contact us</Link>.</p>
    </div>
  )
}

